import React, { useEffect } from 'react';

import { GMetrixTableColumnProps } from 'components/GMetrixTable/components';
import { KendoPostSearch } from 'components/KendoPostSearch/KendoPostSearch';
import { GMetrixTable } from 'components/GMetrixTable/GMetrixTable';
import { License, LicenseApi } from 'apis/LicenseApi';
import { FieldSettings } from 'utils/dataQuery';
import { useIntl } from 'react-intl';

import 'components/LicenseGMetrixTable/license-gmetrix-table.scss';

interface LicenseGMetrixTableProps<T> {
    advancedSearchFields: FieldSettings[];
    allowExport?: boolean;
    className?: string;
    columnData: GMetrixTableColumnProps<License>[];
    defaultItemsPerPage?: number;
    licenses: License[];
    loadingGridData: boolean;
    manualLoadGridData?: boolean;
    manuallyRenderLicenses?: boolean;
    multiSelect?: boolean;
    onDetailsItemClick?: (dataItem: License) => void | undefined;
    onSelectedChange?: (selected: License[]) => void;
    searchAutoFocus?: boolean;
    searchTerm: string;
    selectableRows?: boolean;
    selectedLicenses?: License[];
    setLicenses: (Licenses: License[]) => void;
    setLoadingGridData: React.Dispatch<React.SetStateAction<boolean>>;
    setSearchTerm: (searchTerm: string) => void;
    toggleColumns?: boolean;
}

export function LicenseGMetrixTable<T>({
    advancedSearchFields,
    allowExport = true,
    className,
    columnData,
    defaultItemsPerPage,
    licenses,
    loadingGridData,
    manuallyRenderLicenses = false,
    multiSelect = true,
    onDetailsItemClick,
    onSelectedChange,
    searchAutoFocus,
    searchTerm,
    selectableRows = false,
    selectedLicenses,
    setLicenses,
    setLoadingGridData,
    setSearchTerm,
    toggleColumns = true
}: LicenseGMetrixTableProps<T>) {

    const { formatMessage } = useIntl();

    useEffect(() => {

        if (!manuallyRenderLicenses) {

            LicenseApi.GetAll(1)
                .then(setLicenses)
                .catch(console.error)
                .finally(() => setLoadingGridData(false));

        }

    }, []);

    return (
        <GMetrixTable
            allowExport={allowExport}
            bottomBarTableName={formatMessage({ id: 'licenses.11b1c36a', defaultMessage: 'Licenses' })}
            columnData={columnData}
            defaultItemsPerPage={defaultItemsPerPage}
            excelExportFileName={formatMessage({ id: 'licenselist.37af1caf', defaultMessage: 'LicenseList' })}
            loading={loadingGridData}
            multiSelect={multiSelect}
            onSelectedChange={onSelectedChange}
            rowData={licenses.filter(license => license.Name.toLowerCase().includes(searchTerm.toLowerCase()))}
            searchAutoFocus={searchAutoFocus}
            searchPlaceholder={formatMessage({ id: 'search_licenses_by_name.323c7b6c', defaultMessage: 'Search licenses by name...' })}
            searchTerm={searchTerm}
            selectableRows={selectableRows}
            selected={selectedLicenses}
            setSearchTerm={setSearchTerm}
            toggleColumns={toggleColumns}
        />
    );

}
